import { Component, OnInit, OnDestroy, DoCheck} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { CommonService } from '../_service/common.service';
import { PagerService } from '../_service/pager-service';
import { interval, Subject, Subscription } from 'rxjs';
import { appConfig, baseUrl, dev, int, intUrl, localUrl, opeUrl, opewafUrl, opeNewwafUrl ,share } from '../app.config';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WorkSheet, WorkBook, utils, writeFile } from 'xlsx';
import { SupplierService } from '../_service/supplier.service';
import { purchasingApiService } from '../_service/purchasing.service';
import { CountryService } from '../_service/country.service';
import { SitesService } from '../_service/sites.service';
import { AddressService } from '../_service/address.service';

@Component({
    selector: 'app-supplier-group',
    templateUrl: './supplier-group.component.html',
    styleUrls: ['./supplier-group.component.css'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
        MatSelectModule, MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, NgxPaginationModule, NgSelectModule, NgbModule,
        NgxMatSelectSearchModule, SortPipe, LazyLoadImgDirective,
        HelpsectionComponent, SuppliertabComponent
    ]
})
export class SupplierGroupComponent implements OnInit, OnDestroy, DoCheck {
  private static readonly DEBOUNCE_TIME_STANDARD_MS = 400;
  private static readonly DEBOUNCE_TIME_COMMODITY_CODE_MS = 500;
  private static readonly DEFAULT_PAGE_SIZE = 20;
  private static readonly TWO = 2;
  private static readonly THREE = 3;
  private static readonly FIVE = 5;
  private static readonly NINE = 9;
  private static readonly TEN = 10;
  private static readonly TWENTY = 20;
  private static readonly THIRTY_FIVE = 35;
  private static readonly ONE_HUNDRED_SEVEN = 107;
  private static readonly KEY_ENTER = 13;
  private static readonly ONE_SECOND_MS = 1000;
  private static readonly TWO_THOUSAND_MS = 2000;
  private static readonly THREE_THOUSAND_MS = 3000;
  private static readonly FIVE_THOUSAND_MS = 5000;
  private static readonly PAGE_HEIGHT_ROW_FACTOR = 50;
  private static readonly PAGE_HEIGHT_BASE_OFFSET = 300;
  private static readonly PAGE_HEIGHT_FALLBACK = 550;

  private readonly ngUnsubscribe = new Subject();
  title = 'Renault Digital frontend';
  myControl = new UntypedFormControl();
  loading =  false;
  Config: any;
  closeBtn: any;
  saveDatas: any = "Save";
  public identifierTypes: any = [];
  public businessEntityIdentifierTypes: any = [];
  public identifierValue: any = [];
  public identifierName: any = [];
  public identifierValueModify: any = [];
  public identifierValueLists: any = [];
  public identifierLists: any = [];
  public supplierDataLists: any = [];
  public data: any = [];
  public suppliervalDropDown: any = [];
  public supplieriDvalDropDown: any = [];
  public supplierCommodityCodes: any = [];
  public supplierNameDropDown: any = [];
  public supplierNameNewDropDown: any = [];
  public groupIdentifierKeys: any = [];
  public groupCategories: any = [];
  public groupStatuses: any = [
    { value: 'VALIDATED', displayName: 'Active' },
    { value: 'ARCHIVED', displayName: 'Archived' },
  ];
  public groupNameModel: any = '';
  public groupCategoryModel: any = '';
  public groupCommodityCodeModel: any = '';
  public groupCommodityCodeModelLabel = '';
  public groupNameModelError =  false;
  public groupCategoryModelError =  false;
  public commodityCodes: any = [];
  public commodityCodeids: any = [];
  commodityCodeScopeRowid: any = '';
  arrCommoditycodes =  false;
  info: any;
  selectedValue = '';
  params = '';
  identifierTypeModel = '';
  identifierValueModel ='';
  identifierValueModellabel = '' ;
  supplierNameModel = '';
  supplierNameModellabel = '';
  paramSplited = '' ;
  listFlag =  false;
  supplierids: any;
  supplieridNames: any;
  configa: any;

  pager: any = {};

  pagedItems: any[];
  paged = 1;
  pagedTotalItem = 0;

  public minlength = SupplierGroupComponent.FIVE;
  userQuestionUpdate = new UntypedFormControl();
  userQuestionUpdate2 = new UntypedFormControl();
  userQuestionUpdate3 = new Subject<string>();

  tempvar: any = '';
  public commoditycodeloaded =  false;
  public commoditycodeloadedcheck =  true;
  public commoditycodevalueSelected =  false;

  public groupsAndGroupIdentifiers: any = [];
  public groupBalanceField: any = [];
  public colors = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "PENDING_VALIDATION", color: "#B7783C" },
    { status: "DRAFT", color: "#CB4B32" },
    { status: "VALIDATED", color: "#5CBA63" },
    { status: "ARCHIVED", color: "#CB4B32" },
    { status: "", color: "white" },
    { status: "PENDING", color: "#B7783C" }

  ];


  public envHide: any = "";
  public customLoadingTemplate: any;
  public roleVariableHide = false;
  public alphabetsArray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  public filterGrpModel = '';
  public bvdAccToGrpIden = [];
  public prodHide = false;
  public superUserShow: any = false;
  public maxGrpNameLength = '60';
  public groupShortNameError = false;
  public groupShortNameRegExError = false;
  public groupShortNameExistsError = false;
  public groupShortName: any = '';
  public showBuyerProfile: any = false;
  public groupShortNameVal: any = [];
  public showForConsult = false;
  showForSupplier: boolean;
  public groupNameModelRegExError = false;
  disableGroupCreateBtn: boolean;
  pageHeight = 0;


  subscription: Subscription;
  timerForBatchStart: any;
  grBatchPageHolder = '';
  stopGRBatch =  false;
  GRBatchIsRunning =  false;
  batchObj: any = {};
  public grTextDisp = 'Loading Please Wait....';
  public pageBatchNo: any = '';
  public showDownloadLog = false;
  allGroupData: any = [];
  public CIdentifierTypes: any = [];
  public IdenKeywithId: any = [];
  groupAllianceIdentifier: any = [];
  CaptCountry = [];
  countrySelList = [];
  CountryNameKeyId: any = [];
  selectedCountry = '';
  tempVarCounList: any;
  CityNameKeyId: any = [];
  varIsMergingSite = '2';
  public newCategoryAssignment = '6';
  public newCategoryName = 'SUPPLIER SITE'
  public qualifierChangetoPending = ['P11', 'P05', 'P06', 'P19', 'P07', 'P09', 'P08'];
  siteCityModel: string;
  siteCountryModel: string;
  CaptCity: any = [];
  public arrBasedOnVal = [];
  public cpyAlcorToRaft = [];
  selectedCustomCountry = '';
  tableDataForSetGRBatch: any = [];
  groupid: any;
  params1: string;
  splitedParams: string;
  categoryDropdown = false;
  statusDropdown = false;
  selectedcategory: string;
  autoload = false;
  autoload1 = false;
  key = 'name';
  reverse =  false;
  enterKey: boolean;
  roleIsManager: boolean;
  constructor(public readonly apiService: CommonService, private readonly router: Router, private readonly pagerService: PagerService, private readonly supplierService: SupplierService, private readonly purchasingService: purchasingApiService, private readonly countryService: CountryService, private readonly sitesService: SitesService, private readonly addressService: AddressService) {
    this.Config = appConfig;
    this.configa = {
      itemsPerPage: SupplierGroupComponent.TEN,
      currentPage: 1,
      totalItems: this.supplierDataLists.length
    };

    this.userQuestionUpdate.valueChanges.pipe(
      debounceTime(SupplierGroupComponent.DEBOUNCE_TIME_STANDARD_MS),
      distinctUntilChanged())
      .subscribe(value => {
        if (this.categoryDropdown || this.statusDropdown) {
          return;
        }
        this.identifierValueModel = value
        this.getidentifierValues(value);
      });
    this.userQuestionUpdate2.valueChanges.pipe(
      debounceTime(SupplierGroupComponent.DEBOUNCE_TIME_STANDARD_MS),
      distinctUntilChanged())
      .subscribe(value => {
        this.supplierNameModel = value
        this.getidentifierValues(value);
      });
    this.userQuestionUpdate3.pipe(
      debounceTime(SupplierGroupComponent.DEBOUNCE_TIME_COMMODITY_CODE_MS),
      distinctUntilChanged())
      .subscribe(value => {
        if (this.commoditycodeloadedcheck === true) {
          this.getCommodityCodes(value);
        } else {
          this.commoditycodeloadedcheck = true;
        }
      });
  }

  ngOnInit() {
    this.supplierids = {};
    this.supplieridNames = {};
    this.getGroupIdentifierKeys();
    this.getGroupCategories();
  }

  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    const RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService) {
    const c = RoleByService;

    if (c['userAccess'] !== undefined && !c['userAccess'].includes('Deined')) {
      if (c['buyer'] === 'yes') {
        this.showBuyerProfile = false;
      } else {
        this.showBuyerProfile = true;
      }
      if (c['role'].includes('manager')) {
        this.roleIsManager = true;
      } else {
        this.roleIsManager = false;
      }
      if (c['env'] === 'qua' || c['env'] === 're7' || c['env'] === 'ope') {
        this.envHide = false;
      } else {
        this.envHide = true;
      }
      if (c['role'] === 'admin' || c['role'].includes('admin')) {
        this.roleVariableHide = true;
      } else {
        this.roleVariableHide = false;
      }
      if (c['superAdmin'] === 'yes') {
        this.superUserShow = true;
      } else {
        this.superUserShow = false;
      }

      if (c['env'] === 'ope') {
        this.prodHide = true;
      } else {
        this.prodHide = false;
      }

      if (c['role'] === 'consult' || c['role'].includes('consult')) {
        this.showForConsult = false;
      } else {
        this.showForConsult = true;
      }

      if (c['role'] === 'supplier') {
        this.showForSupplier = false;
      } else {
        this.showForSupplier = true;
      }
    }
  }

  restAlldatas() {
    if (this.identifierTypeModel.toLowerCase() == "groups") {
      this.minlength = SupplierGroupComponent.FIVE;
    } else {
      this.minlength = SupplierGroupComponent.TWO;
    }
    this.supplierNameModel = '';
    this.userQuestionUpdate2.setValue('', { emitEvent: false });
    this.userQuestionUpdate.setValue('', { emitEvent: false });
    this.supplieriDvalDropDown = [];
    if (this.identifierTypeModel.toLowerCase() == 'category') {
      this.categoryDropdown = true;
      this.statusDropdown = false;
      const externalSupplierCat = this.groupCategories.find((cat: any) =>
        (cat.groupTypeCode ?? '').toLowerCase() === 'external supplier'
      );
      this.identifierValueModel = externalSupplierCat ? externalSupplierCat.groupTypeCode : '';
    } else if (this.identifierTypeModel.toLowerCase() == 'status') {
      this.statusDropdown = true;
      this.categoryDropdown = false;
      this.identifierValueModel = '';
    } else {
      this.categoryDropdown = false;
      this.statusDropdown = false;
      this.identifierValueModel = '';
    }
  }

  onIdentifierTypeChange(selectedType: string) {
    this.identifierTypeModel = selectedType || '';
    this.restAlldatas();
  }

  getidentifierValues(event: any) {
    if (this.supplierNameModel != '' && this.identifierValueModel == '') {
      this.minlength = SupplierGroupComponent.THREE;
    }
    if (event.length >= this.minlength) {
      let splitted = this.identifierTypeModel.split("$$");
      let splitted1 = this.identifierTypeModel.split("%%");
      console.info("splitted", splitted1[1])
      console.info("splitted", splitted)
      var params = '';
      let params1 = ''
      if (this.identifierValueModel != '' && this.identifierTypeModel != '' && this.supplierNameModel == '') {
        if (splitted[0] == 'groups') {
          var params = `${splitted[0]}?allianceIdentifier=*${this.identifierValueModel.trim()}*&_page=1`;
          params1 = 'groups'
        }
        else if (splitted[0] == 'group-identifiers' && splitted[1] != '1') {
          var params = `group-identifiers?groupIdentifierKeyId=${splitted[1]}&value=*${this.identifierValueModel.trim()}*&_page=1`;
          params1 = 'group-identifiers'
        }
        else if (splitted[1] == '1') {
          this.autoload1 = true;
          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD%20ID&value=*${this.identifierValueModel.trim()}*&_page=1`).subscribe(data00 => {
            if (data00 && data00 != null) {
              this.supplieriDvalDropDown = [];
              let k = 0;
              for (let i = 0; i < data00['business-entity-identifiers'].length; i++) {
                this.supplieriDvalDropDown[k] = data00['business-entity-identifiers'][i]['value'];
                this.supplierids[data00['business-entity-identifiers'][i]['value']] = data00['business-entity-identifiers'][i]['row_id'];
                k++;
              }
              this.autoload1 = false;
            }
          });
        }
        if (params != '') {
          this.autoload1 = true;
          var load: any;
          if (params1 == 'groups') {
            load = this.supplierService.getGroups(this.Config.ApiSupplierUrl + params);
          } if (params1 == 'group-identifiers') {
            load = this.supplierService.getGroupIdentifiers(this.Config.ApiSupplierUrl + params);
          }
          load.subscribe((data: any) => {
            if (data && data != null) {
              this.supplieriDvalDropDown = [];
              this.supplierids = [];
              console.info("data-search====>", data);
              let k = 0;
              for (let i = 0; i < data[splitted[0]].length; i++) {
                if (splitted[0] == 'groups') {
                  this.supplieriDvalDropDown[k] = data['groups'][i]['allianceIdentifier'];
                  this.supplierids[data['groups'][i]['allianceIdentifier']] = data['groups'][i]['row_id'];
                  k++;
                } else if (splitted[0] == 'group-identifiers') {
                  this.supplieriDvalDropDown[k] = data['group-identifiers'][i]['value'];
                  this.supplierids[data['group-identifiers'][i]['value']] = data['group-identifiers'][i]['row_id'];
                  k++;
                }
              }
              this.autoload1 = false;
            } else {
              this.supplieriDvalDropDown = [];
              this.supplierids = [];
            }
          });
        } else {
          this.supplieriDvalDropDown = [];
          this.supplierids = [];
        }
      } else if (this.identifierValueModel == '' && this.supplierNameModel != '') {
        var params = `groups?name=*${encodeURIComponent(this.supplierNameModel).trim()}*&_page=1`;
        params1 = 'groups';
        if (params != '') {
          this.autoload = true;
          var load: any;
          if (params1 == 'groups') {
            load = this.supplierService.getGroups(this.Config.ApiSupplierUrl + params);
          }
          load.subscribe((data: any) => {
            if (data && data != null) {
              this.supplierNameNewDropDown = [];
              this.supplieridNames = [];
              let k = 0;
              for (let i = 0; i < data['groups'].length; i++) {
                this.supplierNameNewDropDown[k] = data['groups'][i]['name'];
                this.supplieridNames[data['groups'][i]['name']] = data['groups'][i]['row_id'];
                this.autoload = false;
                k++;
              }
              this.autoload = false;
            } else {
              this.supplierNameNewDropDown = [];
              this.supplieridNames = [];
              this.autoload = false;
            }
          });
        } else {
          this.supplierNameNewDropDown = [];
          this.supplieridNames = [];
          this.autoload = false;
        }
      } else {
        this.supplieriDvalDropDown = [];
        this.supplierids = [];
        this.supplierNameNewDropDown = [];
        this.supplieridNames = [];
      }
    } else {
      this.supplieriDvalDropDown = [];
      this.supplierids = [];
      this.supplierNameNewDropDown = [];
      this.supplieridNames = [];
    }
  }

  pageChanged(event) {
    this.configa.currentPage = event;
  }

  datalistIderntifireSearch() {
    var data = Object.keys(document).sort(),
      datalist = document.getElementById("staticUserIds");
    var term = this.identifierValueModellabel.toLowerCase();
    if (term.length >= SupplierGroupComponent.TWO) {
      let found = 0;
      let frag = document.createDocumentFragment();
      for (let child of [].slice.apply(datalist.childNodes)) {
        datalist.removeChild(child);
      }
      for (let item of this.suppliervalDropDown) {
        if ((item.allianceIdentifierSelect != undefined && item.allianceIdentifierSelect.toLowerCase().includes(term.toLowerCase()))) {
          let option = document.createElement("option");
          option.value = item.allianceIdentifierSelect
          frag.appendChild(option);
          if (++found > SupplierGroupComponent.TEN) break;
        }
      }
      datalist.appendChild(frag);
    } else {
      for (let child of [].slice.apply(datalist.childNodes)) {
        datalist.removeChild(child);
      }
    }
  }
  datalistGroupnameSearch() {
    var data = Object.keys(document).sort(),
      datalist = document.getElementById("staticUserIds1");
    var term = this.supplierNameModellabel.toLowerCase();
    if (term.length >= SupplierGroupComponent.TWO) {
      let found = 0;
      let frag = document.createDocumentFragment();
      for (let child of [].slice.apply(datalist.childNodes)) {
        datalist.removeChild(child);
      }
      for (let item of this.supplierNameDropDown) {
        if ((item.allianceIdentifierLegalname != undefined && item.allianceIdentifierLegalname.toLowerCase().includes(term.toLowerCase()))) {
          let option = document.createElement("option");
          option.value = item.allianceIdentifierLegalname
          frag.appendChild(option);
          if (++found > SupplierGroupComponent.TEN) break;
        }
      }
      datalist.appendChild(frag);
    } else {
      for (let child of [].slice.apply(datalist.childNodes)) {
        datalist.removeChild(child);
      }
    }
  }
  updateCreateGroupExistsName() {
    this.groupNameModel = '';
    const bopCategory = this.groupCategories && this.groupCategories.find(cat => {
      const type = (cat.groupTypeCode ?? '').toLowerCase();
      return type === 'bop/nbop' || type === 'external supplier';
    });
    if (bopCategory) {
      this.groupCategoryModel = bopCategory.row_id;
    } else {
      this.groupCategoryModel = '';
    }
    this.groupCommodityCodeModel = '';
    this.groupShortName = '';
    this.groupNameModelError = false;
    this.groupShortNameError = false;
    this.groupShortNameRegExError = false;
    this.groupShortNameExistsError = false;
    this.groupCategoryModelError = false;
    this.commodityCodes = [];
    this.supplierCommodityCodes = [];
    this.commodityCodeids = [];
    this.groupNameModelRegExError = false;
    this.disableGroupCreateBtn = false;
  }


  resetGroupShortNameFields() {
    this.groupShortNameExistsError = false;
    this.groupShortNameRegExError = false;
    this.groupShortName = '';
    this.groupShortNameError = true;
  }

  checkvalidateGroupNameField() {
    if (this.groupNameModel == '') {
      this.groupNameModelError = true;
    } else {
      this.groupNameModelError = false;
    }
  }
  resetGrouNameFields() {
    this.groupNameModel = '';
    this.groupNameModelError = true;
    this.groupNameModelRegExError = false;
  }
  checkvalidateGroupCategoryField() {
    if (this.groupCategoryModel == '') {
      this.groupCategoryModelError = true;
    } else {
      this.groupCategoryModelError = false;
    }
  }
  setCommodityCodeModel() {
    this.commoditycodevalueSelected = true;
    if (typeof this.commodityCodeids[this.groupCommodityCodeModelLabel] != 'undefined') {
      this.groupCommodityCodeModel = this.commodityCodeids[this.groupCommodityCodeModelLabel];
      this.commoditycodeloadedcheck = false;
    } else {
      this.groupCommodityCodeModel = '';
      this.commoditycodeloadedcheck = true;
    }
    return false;
  }
  getGroupCategories(page = 1, subscribeData = []) {
    this.groupCategories = [];
    this.supplierService.getGroupTypes(`${this.Config.ApiSupplierUrl}group-types?_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['group-types'] && data['group-types'] != null) {
        data['group-types'].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupCategories(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          this.groupCategories = subscribeData;
          const bopCategory = this.groupCategories.find((cat: any) => {
            const type = (cat.groupTypeCode ?? '').toLowerCase();
            return type === 'bop/nbop' || type === 'external supplier';
          });
          if (bopCategory) {
            this.groupCategoryModel = bopCategory.row_id;
          }
        }
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  getCommodityCodes(codes: any) {
    console.info("codes==>", codes);

    if (this.tempvar != codes && codes.length > 1) {
      this.commoditycodeloaded = true;
      this.commoditycodeloadedcheck = false;
      this.tempvar = codes;
      this.commodityCodes = [];
      this.supplierCommodityCodes = [];
      this.commodityCodeids = [];
      var cod = codes.split(' - ');
      this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&typeScope=BOP&code=*${encodeURI(cod['0'].toLowerCase())}*&_page=1`).subscribe((data: any) => {
        if (data && data != null) {
          let j = 0;
          for (let i = 0; i < data['commodity-perimeters'].length; i++) {

            this.commodityCodes[j] = data['commodity-perimeters'][i];
            this.commodityCodes[j]['code_label'] = `${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`;
            this.supplierCommodityCodes[j] = `${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`;
            this.commodityCodeids[`${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`] = data['commodity-perimeters'][i]['rowId'];
            j++;
          }

          console.info("commodityCodes===>", this.commodityCodes);
          console.info("commodityCodeids===>", this.commodityCodeids);
          this.commoditycodeloadedcheck = false;
        }

        this.commoditycodevalueSelected = false;
        this.commoditycodeloaded = false;


      }, error => {
        console.info('data_error', error);
      });
    }
    return "ok";
  }

  saveGroupDetails() {
    let proceedShortName = false;
    var grpIdentifierKeyId = "";

    if (this.groupNameModel != '' && this.groupNameModel != undefined && this.groupCategoryModel != '' && this.groupCategoryModel != undefined && this.groupShortName != '' && this.groupShortName != undefined && this.groupShortNameRegExError == false && this.groupNameModelRegExError == false) {
      this.disableGroupCreateBtn = true;
      this.supplierService.getGroupIdentifierKeys(`${this.Config.ApiSupplierUrl}group-identifier-keys`).subscribe((data18: any) => {
        data18['group-identifier-keys'].forEach(element => {
          if (element.name.toLowerCase() == "mdm group") {
            grpIdentifierKeyId = element.row_id;
          }
        });
        this.saveDatas = "Save...";
        this.groupShortNameError = false;
        this.groupShortNameExistsError = false;
        this.groupNameModelError = false;
        this.groupCategoryModelError = false;
        const datas = { name: this.groupNameModel, groupTypes: this.groupCategoryModel, modificationStatus: 'VALIDATED', startDate: this.apiService.getTodayDate() };
        this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${this.groupShortName}&_page=1`).subscribe(data0 => {
          if (data0['pageCount'] == 0) {
            proceedShortName = true;
            this.groupShortNameExistsError = false;
          } else {
            this.saveDatas = 'Save';
            this.groupShortNameExistsError = true;
            proceedShortName = false;
          }
          if (proceedShortName) {
            this.supplierService.createGroups(`${this.Config.ApiSupplierUrl}groups`, datas).subscribe((dataGroup: any) => {
              const datas2 = {
                "groupId": dataGroup['row_id'],
                "value": this.groupShortName,
                "groupIdentifierKeyId": grpIdentifierKeyId,
                "startDate": this.apiService.getTodayDate()
              }
              this.supplierService.CreateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers`, datas2).subscribe(_data => {

              });
              this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?code=prospect`).subscribe((data: any) => {
                this.commodityCodeScopeRowid = data['approval-scopes'][0]['row_id'];
                if (this.commodityCodeScopeRowid != '') {
                  let datas;
                  if (this.groupCommodityCodeModel != '') {
                    datas = { groupPwo: `SupPurchasingWorkingOrganizationService:${this.groupCommodityCodeModel}`, groupId: dataGroup['row_id'], scopeId: this.commodityCodeScopeRowid, type: 'GROUP', scopeCode: 'Prospect', approvalModificationStatus: 'PENDING_VALIDATION', validityStartDate: this.apiService.getTodayDate() };
                  } else {
                    datas = { groupId: dataGroup['row_id'], scopeId: this.commodityCodeScopeRowid, type: 'GROUP', scopeCode: 'Prospect', approvalModificationStatus: 'PENDING_VALIDATION', validityStartDate: this.apiService.getTodayDate() };
                  }
                  this.supplierService.CreateGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals`, datas).subscribe((_dataGApprovals: any) => {
                    this.router.navigate(['/supplier-group-details', dataGroup['row_id']]);
                  });
                }

              });
              window.document.getElementById("closeGCBtn").click();
              this.saveDatas = "Save";
            });
          }
        });
      });
    } else {
      if (this.groupShortName == '') {
        this.groupShortNameError = true;
      }
      if (this.groupNameModel == '' && this.groupCategoryModel == '' && this.groupCommodityCodeModel == '') {
        this.groupNameModelError = true;
        this.groupCategoryModelError = true;
      } else if (this.groupNameModel != '' && this.groupCategoryModel == '' && this.groupCommodityCodeModel == '') {
        this.groupNameModelError = false;
        this.groupCategoryModelError = true;
      } else if (this.groupNameModel == '' && this.groupCategoryModel != '' && this.groupCommodityCodeModel == '') {
        this.groupNameModelError = true;
        this.groupCategoryModelError = false;
      } else if (this.groupNameModel == '' && this.groupCategoryModel == '' && this.groupCommodityCodeModel != '') {
        this.groupNameModelError = true;
        this.groupCategoryModelError = true;
      } else if (this.groupNameModel != '' && this.groupCategoryModel != '' && this.groupCommodityCodeModel == '') {
        this.groupNameModelError = false;
        this.groupCategoryModelError = false;
      } else if (this.groupNameModel != '' && this.groupCategoryModel == '' && this.groupCommodityCodeModel != '') {
        this.groupNameModelError = false;
        this.groupCategoryModelError = true;
      } else if (this.groupNameModel == '' && this.groupCategoryModel != '' && this.groupCommodityCodeModel != '') {
        this.groupNameModelError = true;
        this.groupCategoryModelError = false;
      }
    }
  }



  getGroupIdentifierKeys(page = 1, subscribeData = []) {
    this.supplierService.getGroupIdentifierKeys(`${this.Config.ApiSupplierUrl}group-identifier-keys?_page=${page}`).subscribe((data: any) => {
      if (data["group-identifier-keys"] && data["group-identifier-keys"] != null) {
        data["group-identifier-keys"].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupIdentifierKeys(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          this.groupIdentifierKeys = subscribeData;
          for (let i = 0; i < subscribeData.length; i++) {
            this.groupIdentifierKeys[i]["name"] = subscribeData[i]['name'];
            this.groupIdentifierKeys[i]["row_id"] = subscribeData[i]['row_id'];
          }
          console.info(this.groupIdentifierKeys);
        }
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  getGroupsAndGroupIdentifiers(params) {
    this.loading = true;
    var load1: any;
    load1 = this.supplierService.getGroups(this.Config.ApiSupplierUrl + params);
    load1.subscribe((data: any) => {
      if (data && data != null) {
        this.groupsAndGroupIdentifiers[params] = data[params];
        if (params == 'groups') {
          for (let i = 0; i < data['groups'].length; i++) {
            if (data['groups'][i]['allianceIdentifier'] != undefined) {
              this.groupBalanceField[data['groups'][i]['allianceIdentifier']] = data['groups'][i];

            }
          }
        }
      }
      this.loading = false;
    }, error => {
      this.getGroupsAndGroupIdentifiers(params);
      console.info('data_error', error);
    });
  }

  getIdentifierName(params, _fieldName, _fieldValue) {
    let paramSplited = params.split("/");
    let params1 = '';
    let params2 = '';
    if (paramSplited[1] == undefined) {
      params1 = paramSplited[0];
      params2 = paramSplited[0];;
    } else {
      params1 = paramSplited[0];
      params2 = params;
    }
    if (this.groupsAndGroupIdentifiers && this.groupsAndGroupIdentifiers != null) {
      this.identifierValueLists = [];
      if (this.groupsAndGroupIdentifiers[params1] != undefined) {
        this.identifierName = this.groupsAndGroupIdentifiers[params1];
        let j = 0;
        let k = 0;
        for (let i = 0; i < this.identifierName.length; i++) {
          this.identifierName[i]["allianceIdentifierSelect"] = this.identifierName[i]['allianceIdentifier'];
          this.identifierName[i]["allianceIdentifierLegalname"] = this.identifierName[i]['name'];
          this.identifierName[i]["row_id"] = this.identifierName[i]['row_id'];
          this.identifierValueLists[j] = this.identifierName[i];
          this.identifierValueLists[j]["groupname"] = this.identifierName[i]['name'];
          this.identifierValueLists[j]["groupstatus"] = this.identifierName[i]['modificationStatus'];
          this.identifierValueLists[j]["alliancegroupid"] = this.identifierName[i]['allianceIdentifier'];
          this.identifierValueLists[j]["groupcategory"] = this.identifierName[i]['groupTypeCode'];
          this.identifierValueLists[j]["groupIds"] = this.identifierName[i]['row_id'];
          this.identifierValueLists[j]["panelcommoditycode"] = '';
          j++;
          k++;
        }
        this.supplierDataLists = this.identifierValueLists;
        this.data = this.supplierDataLists;
      }
    }
    this.loading = false;
  }

  getColor(status) {
    return this.colors.filter(item => item.status === status)[0].color
  }

  selectChangeHandler(event: any) {
    this.listFlag = false;
    this.selectedValue = event.target.value;
    var splitted = this.selectedValue.split("$");
    this.identifierValueModel = '';
    this.identifierTypeModel = '';
    this.identifierValueModellabel = '';
    this.supplierNameModel = '';
    this.supplierNameModellabel = '';
  }


  setidentifierValueModel() {
    if (typeof this.supplierids[this.identifierValueModellabel] != 'undefined') {
      this.identifierValueModel = this.identifierValueModellabel;
    } else if (this.identifierValueModellabel != undefined && this.identifierValueModellabel.length >= SupplierGroupComponent.TWO) {
      this.identifierValueModel = this.identifierValueModellabel;
    } else {
      this.identifierValueModel = '';
    }
  }
  setidentifierNameModel(selected) {
    if (selected != null && selected != undefined) {
      this.supplierNameModel = selected;
    } else if (selected != null && typeof this.supplieridNames[selected.initialValue] != 'undefined') {
      this.supplierNameModel = selected;
    } else {
      this.supplierNameModel = '';
    }
  }
  getIdentifierValue(params, _fieldName, _fieldValue) {
    this.params = params;
    this.supplierDataLists = [];
    this.identifierValueLists = [];
    this.identifierValue = [];
    this.data = [];
    if (this.groupsAndGroupIdentifiers && this.groupsAndGroupIdentifiers != null) {
      let paramSplited = params.split("/");
      let typeSplitted = this.identifierTypeModel.split("$$");
      if (this.groupsAndGroupIdentifiers[paramSplited[0]] != undefined) {
        this.identifierValue = this.groupsAndGroupIdentifiers[paramSplited[0]];
        let j = 0;
        let k = 0;
        for (let i = 0; i < this.identifierValue.length; i++) {
          if (paramSplited[0] == 'groups') {
            this.identifierValue[i]["allianceIdentifierSelect"] = this.identifierValue[i]['allianceIdentifier'];
            this.identifierValue[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['allianceIdentifier'];
            this.identifierValue[i]["row_id"] = this.identifierValue[i]['row_id'];
            this.identifierValueLists[j] = this.identifierValue[i];
            this.identifierValueLists[j]["groupname"] = this.identifierValue[i]['name'];
            this.identifierValueLists[j]["groupIds"] = this.identifierValue[i]['row_id'];
            this.identifierValueLists[j]["groupstatus"] = this.identifierValue[i]['modificationStatus'];
            this.identifierValueLists[j]["alliancegroupid"] = this.identifierValue[i]['allianceIdentifier'];
            this.identifierValueLists[j]["groupcategory"] = this.identifierValue[i]['groupTypeCode'];
            this.identifierValueLists[j]["panelcommoditycode"] = '';
            j++;
            k++;
          } else if (paramSplited[0] == 'group-identifiers') {
            this.identifierValue[i]["allianceIdentifierSelect"] = this.identifierValue[i]['value'];
            this.identifierValue[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['value'];
            this.identifierValue[i]["row_id"] = this.identifierValue[i]['row_id'];
            this.identifierValueLists[j] = this.identifierValue[i];
            this.identifierValueLists[j]["groupname"] = this.identifierValue[i]['groupName'];
            this.identifierValueLists[j]["alliancegroupid"] = this.identifierValue[i]['groupAllianceIdentifier'];
            this.identifierValueLists[j]["groupIds"] = this.identifierValue[i]['groupId'];
            this.identifierValueLists[j]["groupstatus"] = this.groupBalanceField[this.identifierValue[i]['groupAllianceIdentifier']]['modificationStatus'];
            this.identifierValueLists[j]["alliancegroupid"] = this.groupBalanceField[this.identifierValue[i]['groupAllianceIdentifier']]['allianceIdentifier'];
            this.identifierValueLists[j]["groupcategory"] = this.groupBalanceField[this.identifierValue[i]['groupAllianceIdentifier']]['groupTypeCode'];
            this.identifierValueLists[j]["panelcommoditycode"] = '';
            j++;
            k++;
          }
        }
        this.supplierDataLists = this.identifierValueLists;
        this.data = this.supplierDataLists;
        console.info(this.data)
      }
    }
    this.loading = false;
  }
  getGroupBalanceField(allianceIdentifier, indexi) {
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups`).subscribe((data: any) => {
      if (data && data != null) {
        let j = 0;
        for (let i = 0; i < data['groups'].length; i++) {
          if (data['groups'][i]['allianceIdentifier'] == allianceIdentifier) {
            this.identifierValueLists[indexi]["groupstatus"] = data['groups'][i]['modificationStatus'];
            this.identifierValueLists[indexi]["alliancegroupid"] = data['groups'][i]['allianceIdentifier'];
            this.identifierValueLists[indexi]["groupcategory"] = data['groups'][i]['groupTypeCode'];
          }
        }

      }

    }, error => {
      console.info('data_error', error);
    });

  }
  onItemKey(event) {
    if (event['keyCode'] == SupplierGroupComponent.KEY_ENTER) {
      this.enterKey = false;
      this.getChangeHandler(1);
    } else {
      this.enterKey = true;
    }
  }

  getChangeHandler(curr_page) {
    this.loading = true;
    this.listFlag = true;
    this.supplierDataLists = [];
    this.data = [];
    let splitted = this.identifierTypeModel.split("$$");
    let pagesize = SupplierGroupComponent.TWENTY;

    if (this.identifierValueModel != '' && this.identifierTypeModel != '' && this.supplierNameModel == '' && this.identifierValueModel.length >= this.minlength) {
      if (splitted[0] == 'groups') {
        var params = `${splitted[0]}?allianceIdentifier=${this.identifierValueModel.trim()}&_page=${curr_page}`;
        var splitedParams = splitted[0];
      } else if (splitted[0] == 'category') {
        splitted[0] = 'groups'
        var params = `${splitted[0]}?groupTypeCode=${this.identifierValueModel.trim()}&_page=${curr_page}`;
        var splitedParams = splitted[0];
      } else if (splitted[0] == 'status') {
        splitted[0] = 'groups'
        var params = `${splitted[0]}?modificationStatus=${this.identifierValueModel.trim()}&_page=${curr_page}`;
        var splitedParams = splitted[0];
      } else if (splitted[0] == 'group-identifiers' && splitted[1] != '1') {
        var params = `group-identifiers?groupIdentifierKeyId=${splitted[1]}&value=${this.identifierValueModel.trim()}&_page=${curr_page}`;
        var splitedParams = splitted[0];
      } else if (splitted[1] == '1') {
        let buss = '';
        let groupid = ''
        let comId = '';
        let foundValidData = false;
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD%20ID&value=${this.identifierValueModel.trim()}&_page=1`).subscribe(data00 => {
          if (data00['business-entity-identifiers'].length > 0) {
            let processedCount = 0;
            const totalCount = data00['business-entity-identifiers'].length;
            data00['business-entity-identifiers'].forEach(element => {
              this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?identifier=${element.businessEntityAllianceIdentifier}`).subscribe(data01 => {
                if (data01['business-entities'] && data01['business-entities'].length > 0) {
                  data01['business-entities'].forEach(elemen => {
                    console.info("ishq", elemen.isHQ)
                    // if (elemen.isHQ == 'Y') {
                      foundValidData = true;
                    buss = elemen.companyId;
                    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?companyId=${buss}&_page=1`).subscribe(data6 => {
                      data6['group-assignments'].forEach(elem => {
                        if (elem.apoStatus != "INACTIVE") {
                          groupid = elem.groupAllianceIdentifier;
                          comId = elem.companyId;
                        }
                      });
                      if (this.listFlag == true && groupid) {
                        this.groupsAndGroupIdentifiers = [];
                        this.groupBalanceField = [];
                        this.identifierValue = [];
                        this.identifierValueLists = [];
                        this.data = [];
                        this.identifierName = [];
                        this.supplierDataLists = [];
                        this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupAllianceIdentifier=${groupid}&_page=1`).subscribe(data6 => {
                          data6['group-identifiers'].forEach(element => {
                            element['representingCompanyId'] = comId;
                          });
                          var splitedParams = 'group-identifiers';
                          this.pagedTotalItem = data6['count'];
                          if (data6['pageCount'] <= SupplierGroupComponent.TEN) {
                            this.pageHeight = data6['pageCount'] * SupplierGroupComponent.PAGE_HEIGHT_ROW_FACTOR + SupplierGroupComponent.PAGE_HEIGHT_BASE_OFFSET;
                          } else {
                            this.pageHeight = SupplierGroupComponent.PAGE_HEIGHT_FALLBACK;
                          }
                          if (data6 && data6 != null) {
                            this.groupsAndGroupIdentifiers[splitedParams] = data6[splitedParams];
                            if (splitted[0] == 'group-identifiers' && data6['count'] > 0 && this.supplierNameModel == '') {
                              var groupids = '';
                              let groupRowIdsUP = [];
                              let groupIdsForIDen = [];
                              let bvdid = [];
                              for (let i = 0; i < data6[splitted[0]].length; i++) {
                                groupRowIdsUP.push(data6[splitted[0]][i].groupId);
                                groupids += `'${data6[splitted[0]][i].groupAllianceIdentifier}',`;
                                groupIdsForIDen.push(`'${data6[splitted[0]][i].groupAllianceIdentifier}'`);
                                if (data6[splitted[0]][i]['representingCompanyId']) {
                                  bvdid.push(data6[splitted[0]][i]['representingCompanyId'])
                                }
                                this.getGroupBvdID(buss);
                              }
                              this.getGroupShortName(groupRowIdsUP);
                              this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=in(${groupids.slice(0, -1)})&page=1 `).subscribe((data1: any) => {
                                for (let j = 0; j < data1['groups'].length; j++) {
                                  this.groupBalanceField[data1['groups'][j]['allianceIdentifier']] = data1['groups'][j];
                                }
                                this.pager = this.pagerService.getPager(this.pagedTotalItem, curr_page, SupplierGroupComponent.DEFAULT_PAGE_SIZE);
                                this.getIdentifierValue(splitted[0], 'identiiers', this.identifierValueModel.trim());
                              });
                            }
                          }
                        })
                      } else {
                        this.data = [];
                        this.loading = false;
                        this.listFlag = false
                      }
                    })
                  // }
                });
                }
                processedCount++;
                if (processedCount === totalCount && !foundValidData) {
                  this.loading = false;
                  this.data = [];
                  this.listFlag = false;
                }
              }, _error => {
                processedCount++;
                if (processedCount === totalCount) {
                  this.loading = false;
                }
              })
            });
          }
          else {
            this.loading = false;
          }
        })
      }
    } else if (this.identifierValueModel == '' && this.supplierNameModel != '' && this.supplierNameModel.length >= this.minlength) {
     var params = `groups?name=*${encodeURIComponent(this.supplierNameModel.trim())}*&_page=${curr_page}`;
      var splitedParams = 'groups';
    } else if (this.filterGrpModel != '' && this.identifierValueModel == '' && this.identifierValueModel == '') {
      console.info('-----------Search by Admin----------');
      this.showNoCpyAssignments(curr_page);
    } else {
      var params = `groups?_page=${curr_page}`;
      var splitedParams = 'groups';
      splitted = [];
      splitted[0] = 'groups';
    }

    if (this.listFlag == true) {
      this.groupsAndGroupIdentifiers = [];
      this.groupBalanceField = [];
      this.identifierValue = [];
      this.identifierValueLists = [];
      this.data = [];
      this.identifierName = [];
      this.supplierDataLists = [];

      if ((params != '' && splitted[1] != '1') || (params != '' && this.supplierNameModel != '')) {
        console.info("splitted1[1]", splitted[1])
        var load2: any;
        if (splitedParams == 'groups') {
          load2 = this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}${params}&_pagesize=${pagesize}`);
        } if (splitedParams == 'category') {
          load2 = this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}${params}&_pagesize=${pagesize}`);
        } if (splitedParams == 'group-identifiers') {
          load2 = this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}${params}&_pagesize=${pagesize}`);
        }
        load2.subscribe((data: any) => {
          console.info("data", data)
          this.pagedTotalItem = data['count'];
          if (data['pageCount'] <= SupplierGroupComponent.TEN) {
            this.pageHeight = data['pageCount'] * SupplierGroupComponent.PAGE_HEIGHT_ROW_FACTOR + SupplierGroupComponent.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = SupplierGroupComponent.PAGE_HEIGHT_FALLBACK;
          }
          if (data && data != null) {
            this.groupsAndGroupIdentifiers[splitedParams] = data[splitedParams];
            console.info("this.groupsAndGroupIdentifiers[splitedParams]", this.groupsAndGroupIdentifiers[splitedParams], splitedParams)
            if (splitted[0] == 'group-identifiers' && data['count'] > 0 && this.supplierNameModel == '') {
              var groupids = '';
              let groupRowIdsUP = [];
              let groupIdsForIDen = [];
              for (let i = 0; i < data[splitted[0]].length; i++) {
                groupRowIdsUP.push(data[splitted[0]][i].groupId);
                groupids += `'${data[splitted[0]][i].groupAllianceIdentifier}',`;
                groupIdsForIDen.push(`'${data[splitted[0]][i].groupAllianceIdentifier}'`);
              }
              this.getGroupBvdID(groupIdsForIDen);
              this.getGroupShortName(groupRowIdsUP);
              this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=in(${groupids.slice(0, -1)})&page=1 `).subscribe((data1: any) => {
                for (let j = 0; j < data1['groups'].length; j++) {
                  this.groupBalanceField[data1['groups'][j]['allianceIdentifier']] = data1['groups'][j];
                }
                this.pager = this.pagerService.getPager(this.pagedTotalItem, curr_page, SupplierGroupComponent.DEFAULT_PAGE_SIZE);
                this.getIdentifierValue(splitted[0], 'identiiers', this.identifierValueModel.trim());
              });
            } else {
              let jVar = '';
              if (this.supplierNameModel != '') {
                jVar = 'groups';
              } else {
                jVar = splitted[0];
              }
              let groupRowIds = [];
              let groupUPROwIds = [];
              let bvdid = []
              let iden = []
              console.info("data[jVar]", data[jVar])
              for (let i = 0; i < data[jVar].length; i++) {
                groupUPROwIds.push(data[jVar][i].row_id);
                groupRowIds.push(`'${data[jVar][i].allianceIdentifier}'`);
                if (data[jVar][i].representingCompanyId) {
                  bvdid.push(data[jVar][i].representingCompanyId)
                }
              }
              this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${bvdid})`).subscribe(data01 => {
                console.info("data01", data01)
                for (let i = 0; i < data01['business-entities'].length; i++) {
                  if (data01['business-entities'][i].identifier) {
                    iden.push(data01['business-entities'][i].identifier)
                  }
                }
              });
              console.info("bvdid", bvdid)
              this.getGroupBvdID(bvdid);
              this.getGroupShortName(groupUPROwIds);
              if (this.identifierValueModel != '') {
                this.pager = this.pagerService.getPager(this.pagedTotalItem, curr_page, SupplierGroupComponent.DEFAULT_PAGE_SIZE);
                this.getIdentifierValue(jVar, 'identiiers', this.identifierValueModel.trim());
              } else if (this.supplierNameModel != '' || splitedParams == 'groups') {
                this.pager = this.pagerService.getPager(this.pagedTotalItem, curr_page, SupplierGroupComponent.DEFAULT_PAGE_SIZE);
                this.getIdentifierName('groups', 'name', this.supplierNameModel.trim());
              }
            }
          }
        });
      }
    }
  }

  resetSelectedFields(resetparam: any) {
    if (this.identifierTypeModel.toLowerCase() == "groups") {
      this.minlength = SupplierGroupComponent.FIVE;
    } else {
      this.minlength = SupplierGroupComponent.TWO;
    }
    if (this.identifierTypeModel.toLowerCase() == "category") {
      this.categoryDropdown = false;
    }
    if (this.identifierTypeModel.toLowerCase() == "status") {
      this.statusDropdown = false;
    }
    if (resetparam == 'supplierNameModellabel') {
      this.supplierNameModel = '';
      this.supplierNameModellabel = '';
      this.filterGrpModel = '';
      this.userQuestionUpdate2.setValue('');
    } else if (resetparam == 'identifierValueModellabel') {
      this.userQuestionUpdate.setValue('')
      this.identifierValueModel = '';
      this.filterGrpModel = '';
      this.minlength = SupplierGroupComponent.THREE;
    } else {
      this.userQuestionUpdate2.setValue('');
      this.userQuestionUpdate.setValue('');
      this.filterGrpModel = '';
      this.identifierValueModel = '';
      this.supplierNameModel = '';
    }
    this.listFlag = false;
    this.supplierDataLists = [];
    this.data = [];
    const selectedType = (this.identifierTypeModel || '').toLowerCase();
    if (selectedType === 'category') {
      this.categoryDropdown = true;
      this.statusDropdown = false;
    } else if (selectedType === 'status') {
      this.categoryDropdown = false;
      this.statusDropdown = true;
    } else {
      this.categoryDropdown = false;
      this.statusDropdown = false;
    }
  }

  customSearchFn1(term: string, item: any) {

    return term && typeof term != 'undefined' && item.allianceIdentifierLegalname.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1 && term.length >= 1;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  onIdentivalueSelect(selected) {
    if (selected != null && selected != undefined) {
      this.identifierValueModel = selected;
    } else if (selected != null && typeof this.supplierids[selected.initialValue] != 'undefined') {
      this.identifierValueModel = selected;
    } else {
      this.identifierValueModel = '';
    }
  }

  saveGroupCode(rowId, nameSliced, count = 0) {
    var temp = nameSliced.slice(0, 1)
    nameSliced = nameSliced.replace(temp, this.alphabetsArray[count]);
    const datasz = {
      "groupId": rowId,
      "value": nameSliced,
      "groupIdentifierKeyId": "1",
      "startDate": this.apiService.getTodayDate()
    }
    count++;
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${nameSliced}&_page=1`).subscribe(data0 => {
      if (data0['pageCount'] == 0) {
        this.supplierService.CreateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers`, datasz).subscribe(_data => {
        });
      } else {
        this.saveGroupCode(rowId, nameSliced, count);
      }
    });
  }

  restNameAndGroup(_params) {
    this.identifierValueModel = '';
    this.supplierNameModel = '';
  }
  showNoCpyAssignments(page, pagesize = SupplierGroupComponent.TWENTY) {
    let paramsUrl = '';
    if (this.filterGrpModel == 'withoutCpy') {
      paramsUrl = 'group-without-assignment';
    } else if (this.filterGrpModel == 'withoutBvdId') {
      paramsUrl = 'group-without-bvd';
    }
    if (paramsUrl != '') {
      var load3: any;
      if (paramsUrl == 'group-without-assignment') {
        load3 = this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}${paramsUrl}?_page=${page}&_pagesize=${pagesize}`)
      } if (paramsUrl == 'group-without-bvd') {
        load3 = this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}${paramsUrl}?_page=${page}&_pagesize=${pagesize}`)
      }
      load3.subscribe(data => {
        let tempRowid = [];
        let groupRowIds = [];
        let count = 0;
        if (data[paramsUrl].length > 0) {
          for (let i = 0; i < data[paramsUrl].length; i++) {
            if (paramsUrl == 'group-without-assignment') {
              if (data[paramsUrl][i]['group-end-date'] == '') {
                groupRowIds.push(data[paramsUrl][i]['row-id']);
                tempRowid.push(`'${data[paramsUrl][i]['group-identifier']}'`);
                count++;
              }
            } else {
              groupRowIds.push(data[paramsUrl][i]['row-id']);
              tempRowid.push(`'${data[paramsUrl][i]['group-identifier']}'`);
            }
          }
          if (paramsUrl == 'group-without-assignment') {
            this.pagedTotalItem = count;
          } else {
            this.pagedTotalItem = data['count'];
          }
          this.pager = this.pagerService.getPager(this.pagedTotalItem, page, pagesize);
          if (data['pageCount'] <= SupplierGroupComponent.TEN) {
            this.pageHeight = data['pageCount'] * SupplierGroupComponent.PAGE_HEIGHT_ROW_FACTOR + SupplierGroupComponent.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = SupplierGroupComponent.PAGE_HEIGHT_FALLBACK;
          }
          this.getGroupShortName(groupRowIds);
          if (paramsUrl != 'group-without-bvd') {
            this.getGroupBvdID(tempRowid);
          }
        }
        if (tempRowid.length != 0) {
          this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=in(${tempRowid})`).subscribe(data1 => {
            if (data1['groups'].length > 0) {
              let dupData = [];
              let c = 0;
              for (let j = 0; j < data1['groups'].length; j++) {
                if (dupData[c] == undefined) {
                  dupData[c] = [];
                }
                dupData[c]["groupname"] = data1['groups'][j]['name'];
                dupData[c]["groupstatus"] = data1['groups'][j]['modificationStatus'];
                dupData[c]["alliancegroupid"] = data1['groups'][j]['allianceIdentifier'];
                dupData[c]["groupcategory"] = data1['groups'][j]['groupTypeCode'];
                dupData[c]["groupIds"] = data1['groups'][j]['row_id'];
                dupData[c]["panelcommoditycode"] = '';
                c++;
              }
              this.data = dupData;
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
        }
      });
    } else {
      this.loading = false;
      this.listFlag = false;
    }
  }

  getGroupBvdID(rowIds, page = 1, splitrowids = [], _remainingRows = [], _morethan20rec = false) {
    let businessEntityIds = [];
    let businessEntityList = [];
    if (rowIds.length > SupplierGroupComponent.TWENTY) {
      splitrowids = rowIds.slice(0, SupplierGroupComponent.TWENTY);
      _remainingRows = rowIds.slice(SupplierGroupComponent.TWENTY, rowIds.length);
      _morethan20rec = true;
    } else {
      splitrowids = rowIds;
      _morethan20rec = false;
    }
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${splitrowids})&_page=${page}`).subscribe(data => {
      if (data['business-entities'].length > 0) {
        businessEntityList = data['business-entities'];
        data['business-entities'].forEach(e => {
          if (e.isHQ == 'Y') {
            if (businessEntityIds.indexOf(e.row_id) == -1) {
              businessEntityIds.push(e.row_id);
            }
          }
        });
      }

      if (rowIds.length > 0) {
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${businessEntityIds})&businessEntityIdentifierTypeName=BVD ID`).subscribe(data => {
          if (data['business-entity-identifiers'].length > 0) {
            data['business-entity-identifiers'].forEach(ele => {
              let val = businessEntityList.find(x => x.row_id == ele.businessEntityId)
              if (val != null && val != undefined && val != '') {
                this.bvdAccToGrpIden[val.companyId] = ele;
              }
            });
            if (data['maxPage'] > 1 && data['maxPage'] != page) {
              this.getGroupBvdID(rowIds, page + 1);
            }
          }
        });
      }
    });
  }

  getGroupShortName(groupRowIds, page = 1) {
    if (groupRowIds.length > 0) {
      let voidName = 'groupId';
      this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?${voidName}=in(${groupRowIds})&groupIdentifierKeyName=MDM GROUP&_page=${page}`).subscribe(data => {
        if (data['group-identifiers'].length > 0) {
          data['group-identifiers'].forEach(element => {
            if (element.endDate == '') {
              this.groupShortNameVal[element.groupId] = element;
            }
          });
          console.info("short", this.groupShortNameVal)
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getGroupShortName(groupRowIds, page + 1);
          }
        }
      });
    }
  }

  hideEnv() {
    let c = this.apiService.getEnvSpecific();
    if (c == 'ope') {
      this.prodHide = true;
    } else { this.prodHide = false };
  }

  checkvalidateGroupNameRegField(expression, model, modelerror, regexmodel) {
    if (/^\s/.test(expression)) {
      this[model] = expression.trimStart();
      return false;
    }
    if (expression.length > 0) {
      this[modelerror] = false;
      if (!/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/.test(expression)) {
        this[regexmodel] = true;
      } else {
        this[regexmodel] = false;
      }
    } else {
      this[regexmodel] = false;
      this[modelerror] = true;
    }
  }

  openWorkflow() {
    let baseUrl1 = baseUrl
    if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
      window.open(`${share}HOME`);
    }
    else if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/` || baseUrl1 == intUrl) {
      window.open(`${dev}HOME`);
    }
    else {
      window.open(`${int}HOME`);
    }
  }
  grBatchStartCheckOnStart() {
    this.timerForBatchStart = SupplierGroupComponent.FIVE;
    let checkVar = localStorage.getItem('grBatchRunning');
    let isProcess = localStorage.getItem('grBatchProcessingPage');
    if (checkVar == 'yes') {
      this.grBatchPageHolder = isProcess;
      document.getElementById('BtnForshowConfirmStartBatchOnStart').click();
      const source = interval(SupplierGroupComponent.ONE_SECOND_MS);
      this.subscription = source.subscribe(_val => {
        this.timerForBatchStart = this.timerForBatchStart - 1;
        if (this.timerForBatchStart == 0) {
          document.getElementById('closeGRStartBatch').click();
          this.setGRBatchFn(+isProcess, 'continue', SupplierGroupComponent.TWENTY, undefined);
          this.subscription.unsubscribe();
        }
      });
    }
  }

  stopGRBatchAssnExe() {
    this.subscription.unsubscribe();
    this.stopGRBatch = true;
    this.GRBatchIsRunning = false;
    localStorage.setItem('GRBatchRunning', 'no');
  }

  setGRBatchFn(page: any = 1, param = '', pagesize: any = SupplierGroupComponent.TWENTY, maxpage?) {
    let isProcess = localStorage.getItem('grBatchProcessingPage');
    if (param == 'check' && this.GRBatchIsRunning == true) {
      document.getElementById('btnForGRBatch').click();
      return false;
    }
    if (isProcess != null && isProcess != '' && param != 'continue' && param != 'continueNoC') {
      this.grBatchPageHolder = isProcess;
      document.getElementById('btnForGRContinue').click();
    } else if (param == 'continue' || isProcess == '' || isProcess == null || param == 'continueNoC') {
      if (param != 'continueNoC') {
        document.getElementById('btnForGRBatch').click();
      }
      if (param == 'continue') {
        this.stopGRBatch = false;
      }
      console.info(this.stopGRBatch, page, maxpage);
      if (this.stopGRBatch == false && ((page <= maxpage || maxpage == undefined) || page == 1)) {
        this.pageBatchNo = page;
        this.grTextDisp = '<img src="assets/images/loading.gif" alt="loading...">';
        if (page == maxpage) {
          this.showDownloadLog = true;
        } else {
          this.showDownloadLog = false;
        }
        let simArr = [1];
        simArr.forEach((e, _index) => {
          this.batchObj[e] = 'notDone';
        });
        this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?_page=${page}&_pagesize=${pagesize}`).subscribe(data => {
          console.info('api 1');
          localStorage.setItem('GRBatchIsRunning', 'yes');
          this.GRBatchIsRunning = true;
          if (data['maxPage'] == page) {
            this.showDownloadLog = true;
          }
          localStorage.setItem('grBatchProcessingPage', page.toString());
          let grpAllianceIdForGR = '';
          let grpRepCpyIdForGR = '';
          let grpIdForGR = [];
          if (data['pageCount'] > 0) {
            data['groups'].forEach(element => {
              if (element != null) {
                grpAllianceIdForGR = `'${element.allianceIdentifier}'`;
                grpRepCpyIdForGR = element.representingCompanyId;
                grpIdForGR.push(element.row_id);
                this.batchGetGroupIdens(grpAllianceIdForGR, grpIdForGR, grpRepCpyIdForGR, data['maxPage'], page);
              }
            });
            setTimeout(function () {
              this.batchObj[1] = 'done';
              this.fnToCallNextPage(page, data['maxPage']);
            }.bind(this), SupplierGroupComponent.FIVE_THOUSAND_MS);
          } else {
            this.batchObj[1] = 'doneFor';
            this.fnToCallNextPage(page, data['maxPage']);
          }
        });
      }
    }
  }

  batchGetGroupIdens(grpAllianceIdForGR, grpIdForGR, grpRepCpyIdForGR, maxPage, page, _Curpage = 1, groupBvdId: any = [], groupIdenRowId = []) {
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&groupAllianceIdentifier=in(${grpAllianceIdForGR})`).subscribe(data1 => {
      console.info('api 2');
      if (data1['group-identifiers'].length > 0) {
        groupBvdId = data1['group-identifiers'][0]['value'];
        groupIdenRowId.push(data1['group-identifiers'][0]['row_id']);
        if (grpRepCpyIdForGR != '') {
          this.batchGetbusinessEntity(grpRepCpyIdForGR, grpIdForGR, groupBvdId, groupIdenRowId, maxPage, page);
        } else {
          console.info("condition 3", grpIdForGR, groupBvdId, groupIdenRowId)
          this.getGroupAssignments(grpIdForGR, groupBvdId, groupIdenRowId);
        }
        setTimeout(function () {
          this.getTableDataForSetGRBatch(grpIdForGR);
        }.bind(this), SupplierGroupComponent.THREE_THOUSAND_MS);
      } else if (grpRepCpyIdForGR == '') {
        this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=${grpIdForGR}&_page=1`).subscribe(data6 => {
          if (data6['count'] == 1) {
            const const3 = { 'representingCompanyId': data6['group-assignments'][0]['companyId'] }
            this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${grpIdForGR}`, const3).subscribe(_data7 => {
            });
          }
        });
        setTimeout(function () {
          this.getTableDataForSetGRBatch(grpIdForGR);
        }.bind(this), SupplierGroupComponent.THREE_THOUSAND_MS);
      } else {
        setTimeout(function () {
          this.getTableDataForSetGRBatch(grpIdForGR);
        }.bind(this), SupplierGroupComponent.THREE_THOUSAND_MS);
      }
    });
  }

  batchGetbusinessEntity(grpRepCpyIdForGR, grpIdForGR, groupBvdId, groupIdenRowId, _maxPage, _page, _Curpage = 1, companyBvdIds: any = [], isGrpCpyBvdEq = false, grpBvdBusinessEntityId = '') {
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${grpRepCpyIdForGR}`).subscribe(data => {
      console.info('api 3');
      let businessEntities = [];
      if (data['business-entities'].length > 0) {
        data['business-entities'].forEach(e => {
          businessEntities.push(e.row_id);
        });
      }
      if (businessEntities.length > 0) {
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${businessEntities})&businessEntityIdentifierTypeName=BVD ID`).subscribe(data2 => {
          console.info('api 4');
          if (data2['business-entity-identifiers'].length > 0) {
            data2['business-entity-identifiers'].forEach(ele => {
              if (ele.value == groupBvdId) {
                isGrpCpyBvdEq = true;
              }
              companyBvdIds.push(ele.value);
            });
          }

          if (groupBvdId != '' && companyBvdIds.length > 0 && isGrpCpyBvdEq == false) {
            console.info('warnings');
          } else if (groupBvdId != '' && companyBvdIds.length == 0) {
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${groupBvdId}`).subscribe(data3 => {
              if (data3['count'] == 0) {
                this.supplierService.getBuinessEntityIdentifierTypes(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?name=BVD ID&_page=1`).subscribe((data: any) => {
                  var row_id_BVDID = data['business-entity-identifier-types'][0]['row_id'];
                  this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${grpRepCpyIdForGR}&isHQ=Y`).subscribe(data4 => {
                    grpBvdBusinessEntityId = data4['business-entities'][0]['row_id'];
                    const datas_N = { businessEntityId: grpBvdBusinessEntityId, businessEntityIdentifierTypeId: row_id_BVDID, value: groupBvdId, startDate: this.apiService.getTodayDate() };
                    this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, datas_N).subscribe(_data5 => {
                      this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${groupIdenRowId}`).subscribe(_da => { });
                    });
                  });
                });
              } else {
                console.info('warnings');
              }
            });
          } else {
            console.info("1 getgrpassignment", grpIdForGR, groupBvdId, groupIdenRowId)
            this.getGroupAssignments(grpIdForGR, groupBvdId, groupIdenRowId);
          }
        });
      }
    });
  }

  getGroupAssignments(grpIdForGR, groupBvdId, groupIdenRowId, page = 1, subscribeData = [], cpyIds = []) {
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=${grpIdForGR}&_page=${page}`).subscribe(data => {
      data['group-assignments'].forEach(ele => {
        subscribeData.push(ele);
        if (cpyIds.indexOf(ele.companyId) == -1) {
          cpyIds.push(ele.companyId);
        }
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getGroupAssignments(grpIdForGR, groupBvdId, groupIdenRowId, page + 1, subscribeData, cpyIds);
      } else if (data['maxPage'] == page) {
        this.getCpyBusinessEntities(cpyIds, grpIdForGR, groupBvdId, groupIdenRowId);
      }
    });
  }

  getCpyBusinessEntities(cpyIds, grpIdForGR, groupBvdId, groupIdenRowId, page = 1, subscribeData: any = [], businessEntityIds = [], splitrowids = [], morethan20rec = false, remainingRows = [], pageChanged = 'yes') {
    if (cpyIds.length > 0) {
      if (pageChanged == 'yes') {
        if (cpyIds.length > SupplierGroupComponent.TWENTY) {
          splitrowids = cpyIds.slice(0, SupplierGroupComponent.TWENTY);
          remainingRows = cpyIds.slice(SupplierGroupComponent.TWENTY, cpyIds.length);
          morethan20rec = true;
        } else {
          splitrowids = cpyIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['business-entities'].length > 0) {
          data['business-entities'].forEach(e => {
            if (subscribeData[e.row_id] == undefined) {
              subscribeData[e.row_id] = [];
            }
            subscribeData[e.row_id] = e;
            if (businessEntityIds.indexOf(e.row_id) == -1) {
              businessEntityIds.push(e.row_id);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getCpyBusinessEntities(cpyIds, grpIdForGR, groupBvdId, groupIdenRowId, page + 1, subscribeData, businessEntityIds, splitrowids, morethan20rec, remainingRows, 'no');
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getCpyBusinessEntities(remainingRows, grpIdForGR, groupBvdId, groupIdenRowId, 1, subscribeData, businessEntityIds, splitrowids, morethan20rec, remainingRows, 'yes');
          } else {
            this.getBvDIdsForCpy(businessEntityIds, grpIdForGR, groupBvdId, subscribeData, groupIdenRowId);
          }
        }
      });
    }
  }

  getBvDIdsForCpy(beIds, grpIdForGR, groupBvdId, subscribeData1, groupIdenRowId, page = 1, subscribeData: any = [], bvdIds = [], hasCpyBvd = false, splitrowids = [], morethan20rec = false, remainingRows = [], pageChanged = 'yes') {
    if (beIds.length > 0) {
      if (pageChanged == 'yes') {
        if (beIds.length > SupplierGroupComponent.TWENTY) {
          splitrowids = beIds.slice(0, SupplierGroupComponent.TWENTY);
          remainingRows = beIds.slice(SupplierGroupComponent.TWENTY, beIds.length);
          morethan20rec = true;
        } else {
          splitrowids = beIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['business-entity-identifiers'].length > 0) {
          data['business-entity-identifiers'].forEach(e => {
            if (subscribeData[e.value] == undefined) {
              subscribeData[e.value] = [];
            }
            subscribeData[e.value] = e;
            bvdIds.push(e.value);
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getBvDIdsForCpy(beIds, grpIdForGR, groupBvdId, subscribeData1, groupIdenRowId, page + 1, subscribeData, bvdIds, hasCpyBvd, splitrowids, morethan20rec, remainingRows, 'no');
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getBvDIdsForCpy(remainingRows, grpIdForGR, groupBvdId, subscribeData1, groupIdenRowId, 1, subscribeData, bvdIds, hasCpyBvd, splitrowids, morethan20rec, remainingRows, 'yes');
          } else {
            if (bvdIds.length > 0) {
              bvdIds.forEach(e => {
                if (groupBvdId == e) {
                  console.info('case 3');
                  hasCpyBvd = true;
                  let cpyid = '';
                  cpyid = subscribeData1[subscribeData[e].businessEntityId].companyId;
                  const const1 = { 'representingCompanyId': cpyid }
                  this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${grpIdForGR}`, const1).subscribe(_data7 => {
                    this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${groupIdenRowId}`).subscribe(_data8 => {
                    });
                  });
                }
              });
              if (hasCpyBvd == false) {
                this.fnForFourthCase(groupBvdId, grpIdForGR);
              }
            } else {
              this.fnForFourthCase(groupBvdId, grpIdForGR);
            }
          }
        }
      });
    } else {
      this.fnForFourthCase(groupBvdId, grpIdForGR);
    }
  }

  fnForFourthCase(groupBvdId, grpIdForGR) {
    console.info('4th case', grpIdForGR);
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${groupBvdId}`).subscribe(data3 => {
      if (data3['business-entity-identifiers'].length > 0) {

      } else {
        let datas = { 'bvd-id': groupBvdId }
        this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
          var obj = JSON.parse(data.result);
          console.info(obj['Data']);
          if (obj['Data'][0]['CITY'] != '') {
            let nlBvdIdData = obj['Data'][0];
            console.info('datas', nlBvdIdData);
            this.saveCompanyDetails(nlBvdIdData, nlBvdIdData['NAME'], nlBvdIdData['NATIONAL_ID'], grpIdForGR, groupBvdId, 'N', nlBvdIdData['NATIONAL_ID_LABEL'], 'Y');
          }
        }, _error => {
          console.info('warnings');
        });
      }
    });
  }


  AllCompanyIdentifierTypes() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys`).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes();
    });
  }
  saveCompanyDetails(nlBvdIdData, cmpName, cmpMainTaxId, groupId, BvdforComP, RepresentCompany, cmpMainTaxIdLabel, fromCnS = 'N', _fromSpCase = 'N') {
    if (cmpName != '' && cmpName != undefined) {
      this.AllCompanyIdentifierTypes();
      let companyStatusRowid = "";
      let companyRowId: any;
      console.info("**** Create Company is Processing ****");
      console.info(`Company Name : ${cmpName} Main TaxID : ${cmpMainTaxId} Group ID : ${groupId} BvDID for Company${BvdforComP}`);

      var cmpNameTypeID = "";
      this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types`).subscribe((data18: any) => {
        console.info("company-name-types", data18);
        data18['company-name-types'].forEach(element => {
          if (element.name.toLowerCase() == "short name") {
            cmpNameTypeID = element.row_id;
          }
        });
      });

      var StartDates = this.apiService.getTodayDate();
      this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
        data['company-status'].forEach(element => {
          if (element.code.toLowerCase() == "identified") {
            companyStatusRowid = element.row_id
          }
        });
        if (companyStatusRowid != '') {

          const datas = { legalName: cmpName, companyStatusId: companyStatusRowid, companyStatusCode: 'Identified', startDate: StartDates };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies`, datas).subscribe((dataGroup: any) => {
            console.info(`Created new Company ID is : ${dataGroup['rowId']}`);
            if (fromCnS == "Y") {
              companyRowId = dataGroup['rowId'];
            }
            const const3 = { 'representingCompanyId': companyRowId }
            this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const3).subscribe(_data => {
              this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&groupAllianceIdentifier=in('${this.groupAllianceIdentifier}')`).subscribe(data1 => {
                let groupIdenRowId = data1['group-identifiers'][0]['row_id'];
                this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${groupIdenRowId}`).subscribe(_data => {
                });
              });
            });
            if (cmpMainTaxId && cmpMainTaxId.length > 0 && cmpMainTaxId != '') {
              var x = 0;
              console.info("this.IdenKeywithId", this.IdenKeywithId);
              cmpMainTaxId.forEach(element => {
                if (cmpMainTaxIdLabel[x] != null && element != null) {
                  var mainTaxRowid = "";
                  console.info("CMT", cmpMainTaxIdLabel[x]);
                  mainTaxRowid = this.IdenKeywithId[cmpMainTaxIdLabel[x].toLowerCase()];
                  console.info(mainTaxRowid);
                  if (mainTaxRowid != undefined && mainTaxRowid != "") {
                    var datas21 = { linkedCompanyId: dataGroup['rowId'], companyIdentifierTypeId: mainTaxRowid, value: element.replace(" ", ""), startDate: StartDates };
                    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas21).subscribe((_dataGApprovals: any) => {
                    });
                  }
                }
                x++;
              });
            }
            let shortName = cmpName.split(' ').join('');
            if (shortName.length <= SupplierGroupComponent.TEN) {
              shortName = shortName.padEnd(SupplierGroupComponent.TEN);
            } else if (shortName.length > SupplierGroupComponent.TEN) {
              shortName = shortName.slice(0, SupplierGroupComponent.TEN);
            }
            shortName = shortName.substring(0, SupplierGroupComponent.TEN);
            const datas3 = { companyId: dataGroup['rowId'], companyNameTypeId: cmpNameTypeID, "value": shortName, startDate: StartDates }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}/company-names`, datas3).subscribe((_data: any) => {
            });
            const datas5 = {
              "apoStatus": "ACTIVE",
              "companyId": dataGroup['rowId'],
              "groupTypeCode": "",
              "groupId": groupId,
              "validityStartDate": this.apiService.getTodayDate(),
              "status": "VALIDATED",
              "groupTypeId": SupplierGroupComponent.TWO
            };
            this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data: any) => {
              this.saveDatas = "Save";
              console.info("**** Create Company Done ****");
              this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${nlBvdIdData['COUNTRY_ISO_CODE']}&_page=1`).subscribe((data: any) => {
                if (data['count'] > 0) {
                  data['countries'].forEach(element => {
                    let captain_exist = this.CaptCountry.indexOf(element.countryName);
                    let captain_exist1 = this.countrySelList.indexOf(element.countryName);
                    if (captain_exist == -1) {
                      let obj = {};
                      obj['countryCode'] = element['countryCode'];
                      obj['countryName'] = element['countryName'];
                      obj['rowId'] = element['rowId'];
                      this.CountryNameKeyId[element.countryName] = obj;
                      this.CountryNameKeyId[element.countryFullName] = obj;
                    }
                    if (captain_exist1 == -1) {
                      this.countrySelList.push(element.countryName);
                    }
                  });
                }
                let city = this.apiService.hasNoSpecialCharacters(nlBvdIdData['CITY_STANDARDIZED'], nlBvdIdData['CITY']);
                this.getCityList(nlBvdIdData['CITY'], city, nlBvdIdData['COUNTRY_ISO_CODE']);
                if (fromCnS == "Y") {
                  console.info("Company Module");
                  this.saveSitesDetails(cmpName, nlBvdIdData['COUNTRY_ISO_CODE'], city, nlBvdIdData['POSTCODE'], dataGroup['rowId'], BvdforComP, 'S', nlBvdIdData);
                } else {
                  console.info("Group Module");
                  this.saveSitesDetails(cmpName, nlBvdIdData['COUNTRY_ISO_CODE'], city, nlBvdIdData['POSTCODE'], dataGroup['rowId'], BvdforComP, "S", nlBvdIdData);
                }
              });
            });
            if (RepresentCompany == "Y") {
              const const1 = { representingCompanyId: dataGroup['rowId'] }
              this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const1).subscribe(_data => {
              });
            }
          });
        }
      });
    }
  }


  saveSitesDetails(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [], times = 1, counFilter = 'none') {
    console.info("thisBvDdata", thisBvDdata);
    console.info("**** Create Site Processing ****");
    console.info(`Site Name : ${CmpName} ${CityName} Country : ${counName} City Name :${CityName} Postal : ${Postal} Company ID${CompanayID} BvD for Site${BvDidforsite}`);
    console.info('debug>>', this.CountryNameKeyId);
    let snippedCountryName = `the ${counName}`;
    this.selectedCountry = counName;
    if (CityName == undefined || CityName == '' || CityName == null) {
      CityName = 'UNKNOWN';
      console.info('changing city to unknown');
    }
    if (this.CountryNameKeyId[counName] == undefined && this.CountryNameKeyId[snippedCountryName] != undefined) {
      counName = snippedCountryName;
    }
    if (this.CountryNameKeyId[counName] == undefined && times < SupplierGroupComponent.TWO && counName != null && counName != '' && counFilter != 'yes') {
      console.info('No country id found, search in list and retry....');
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counName}&_page=1`).subscribe((data: any) => {
        if (data['count'] > 0) {
          data['countries'].forEach(element => {
            let captain_exist = this.CaptCountry.indexOf(element.countryName);
            let captain_exist1 = this.countrySelList.indexOf(element.countryName);
            if (captain_exist == -1) {
              let obj = {};
              obj['countryCode'] = element['countryCode'];
              obj['countryName'] = element['countryName'];
              obj['rowId'] = element['rowId'];
              this.CountryNameKeyId[element.countryName] = obj;
              this.CountryNameKeyId[element.countryFullName] = obj;
            }
            if (captain_exist1 == -1) {
              this.countrySelList.push(element.countryName);
            }
          });
        }
        this.saveSitesDetails(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, times + 1);
        this.selectedCountry = counName;
        this.tempVarCounList['CmpName'] = CmpName;
        this.tempVarCounList['counName'] = counName;
        this.tempVarCounList['CityName'] = CityName;
        this.tempVarCounList['Postal'] = Postal;
        this.tempVarCounList['CompanayID'] = CompanayID;
        this.tempVarCounList['BvDidforsite'] = BvDidforsite;
        this.tempVarCounList['fromCnS'] = fromCnS;
        this.tempVarCounList['thisBvDdata'] = thisBvDdata;
        this.tempVarCounList['times'] = times;
      });
    } else if (this.CountryNameKeyId[counName] == undefined && times == SupplierGroupComponent.TWO && counFilter != 'yes') {
      console.info('tempVarCounList', this.tempVarCounList);
      document.getElementById('btnForSelectCountryId').click();
    } else {
      let countryId;
      let countryCode;
      let cntryName;
      if (counFilter == 'yes') {
        countryId = this.CountryNameKeyId[counName]['countryId'];
        countryCode = this.CountryNameKeyId[counName]['countryCode'];
        cntryName = this.CountryNameKeyId[counName]['countryName'];
      } else {
        countryId = this.CountryNameKeyId[counName]['countryId'];
        countryCode = this.CountryNameKeyId[counName]['countryCode'];
        cntryName = this.CountryNameKeyId[counName]['countryName'];
      }

      if (this.CityNameKeyId[CityName] == undefined || this.CityNameKeyId[CityName] == 'undefined') {
        this.getCityList(CityName, CityName, counName);
        console.info("CityKey", this.CityNameKeyId);

        setTimeout(function () {
          console.info("ltest", this.CityNameKeyId[CityName]);
          if (this.CityNameKeyId[CityName] != undefined && this.CityNameKeyId[CityName] != 'undefined') {
            var cityId = this.CityNameKeyId[CityName]["rowId"];
            this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
          } else {
            const cityDatas = {
              countryCode: countryCode,
              name: CityName,
              active: "1",
              countryName: cntryName,
              countryId: countryId
            };
            this.countryService.createCities(`${this.Config.ApiCountryUrl}cities`, cityDatas).subscribe((dataCity: any) => {
              var cityId = dataCity["rowId"];
              this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
            });
          }
        }.bind(this), SupplierGroupComponent.TWO_THOUSAND_MS);

      } else {
        var cityId = this.CityNameKeyId[CityName]["rowId"];
        this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
      }
    }
  }

  saveSiteInformation(countryId, cityId, Site_Name, Postal = '', CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = []) {
    console.info("thisBvDdata2", thisBvDdata);
    let SiteRowID = "";
    const siteDatas = {
      cityId: cityId,
      countryId: countryId,
      activeStatus: "ACTIVE",
      name: Site_Name,
      effectiveDate: this.apiService.getTodayDate(),
      "irnAuthor": "IRN-71016",
      "siaAuthor": "IAF",
      "isMergingSite": this.varIsMergingSite,
    };
    this.sitesService.createSite(`${this.Config.ApiSitesUrl}sites`, siteDatas).subscribe((dataSite: any) => {
      var site_row_id = dataSite["rowId"];
      console.info(`Created New site ID is : ${dataSite["rowId"]}`);
      if (fromCnS == "S" || fromCnS == 'W') {
        SiteRowID = dataSite["rowId"];
      }
      const accessPDatas = {
        activeStatus: "ACTIVE",
        realEstateAssetId: site_row_id,
        type: "P14",
        label: Site_Name,
        effectiveDate: this.apiService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF"
      };
      this.sitesService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPDatas).subscribe((dataAccessP: any) => {
        let access_point_row_id = dataAccessP["rowId"];
        let addinfo = "";
        if (thisBvDdata['ADDRESS_LINE1'] == undefined || thisBvDdata['ADDRESS_LINE1'] == '' || thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = 'UNKNOWN';
          console.info('street is null changing to unknown');
        }
        console.info("ADDRESS_LINE1", thisBvDdata['ADDRESS_LINE1']);
        thisBvDdata['ADDRESS_LINE1'] = thisBvDdata['ADDRESS_LINE1'].substring(0, SupplierGroupComponent.THIRTY_FIVE);
        if (thisBvDdata['ADDRESS_LINE2'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += `${thisBvDdata['ADDRESS_LINE2']} `;
        }
        if (thisBvDdata['ADDRESS_LINE3'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += thisBvDdata['ADDRESS_LINE3'];
        }
        let geoADatas = {};
        if (thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = "";
        }
        addinfo = addinfo.substring(0, SupplierGroupComponent.ONE_HUNDRED_SEVEN);
        if (Postal != '' && Postal != null) {
          Postal = Postal.substring(0, SupplierGroupComponent.NINE);
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            postalCode: Postal,
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        } else {
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        }
        this.addressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA: any) => {
          var geo_adress_row_id = dataGeoA["rowId"];
          const accessPointDatas = {
            accessPointId: access_point_row_id,
            addressId: geo_adress_row_id
          };
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint: any) => {
          });

          if ((thisBvDdata['LATITUDE'] != '' && thisBvDdata['LATITUDE'] != null) || (thisBvDdata['LONGITUDE'] != '' && thisBvDdata['LONGITUDE'] != null)) {
            const gpsDatas = { 'accessPointId': access_point_row_id, 'latitude': thisBvDdata['LATITUDE'] ? thisBvDdata['LATITUDE'].toString() : "", 'longitude': thisBvDdata['LONGITUDE'] ? thisBvDdata['LONGITUDE'].toString() : "" }
            console.info("gpsDatas", gpsDatas);
            this.addressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA: any) => {
              console.info("geolocation-coordinates-addresses : ", dataGeoA);
              const accessPointDatas2 = {
                accessPointId: access_point_row_id,
                addressId: dataGeoA['rowId']
              };
              this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint: any) => {

              });
            });
          }
          this.addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS);
        });
      });
    });
  }

  addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS = "N") {
    const newCategory = { "realEstateAssetId": site_row_id, "categoryId": this.newCategoryAssignment, "categoryName": this.newCategoryName }
    this.sitesService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newCategory).subscribe((_data: any) => {
    });
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_row_id}&_page=1&status=VALIDATED`).subscribe(data => {
      if (data['pageCount'] == 1) {
        if (data['site-assignments'][0]['status'] == 'VALIDATED') {
          console.info("SRifalse1");

        } else {
          console.info("SRitrue1");
          this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS);
        }
      } else if (data['pageCount'] > 1) {
        console.info("SRifalse2");
      } else {

        console.info("SRitrue2");
        this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS);
      }
    });
  }


  changeCompanySiteAssnNoExist(siteID, CMPiD, BvDidforsite, Site_Name, fromCnS = "N") {
    var tempBusinessRowId;
    console.info('fromCnS', fromCnS);
    if (fromCnS == "S") {
      const datas2 = { modificationStatus: "VALIDATED", isHQ: "Y", companyId: CMPiD };
      this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas2).subscribe((dataGApprovals: any) => {
        tempBusinessRowId = dataGApprovals['row_id'];
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] > 0) {

          }
          else {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe((_data2: any) => {

            });
          }
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe((_data3: any) => {
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
          })
        });
      });
    } else {
      console.info('in else....');
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${CMPiD}&isHQ=Y`).subscribe(data => {
        tempBusinessRowId = data['business-entities'][0]['row_id'];
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] > 0) {

          }
          else {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe((_data2: any) => {

            });
          }
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe((_data3: any) => {
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
          })
        });
      });
    }
  }

  changeParamsforNewCpy(_con, site_id, CompanayID, Site_Name, BvDidforsite, fromCnS = "N") {
    this.cpyAlcorToRaft = [];
    if (CompanayID != '' && CompanayID != undefined) {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${CompanayID}`).subscribe(data1 => {

        const const1 = { "name": Site_Name }
        this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_id}`, const1).subscribe(_data0 => {

        });
        let shortName
        this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SHORT NAME&companyId=${CompanayID}`).subscribe(data2 => {
          if (data2['company-names'].length > 0) {
            shortName = data2['company-names'][0]['value'];
          } else {
            shortName = data1['legalName'].slice(0, SupplierGroupComponent.TEN);
          }
          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=RAFT_ACCOUNT`).subscribe(data6 => {
            if (data6['real-estate-asset-identifiers'].length > 0) {
              const constEndDate = { "endDate": this.apiService.getTodayDate() }
              data6['real-estate-asset-identifiers'].forEach(ele => {
                this.cpyAlcorToRaft.push(ele.businessIdentifierValue);
                this.arrBasedOnVal[ele.businessIdentifierValue] = ele.rowId;
                this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${ele.rowId}`, constEndDate).subscribe(_data7 => {
                });
              });
            }
            this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${CompanayID}&companyIdentifierKeyName=ALCOR`).subscribe(data8 => {
              if (data8['company-identifiers'].length > 0) {
                let const5;
                if (shortName == '') {
                  shortName = data1['legalName'].slice(0, SupplierGroupComponent.TEN);
                }
                const constNoEndDate = { "endDate": "" }
                data8['company-identifiers'].forEach(elem => {
                  if (this.cpyAlcorToRaft.indexOf(elem.value) == -1) {
                    if (elem.endDate == '') {
                      const5 = {
                        "businessIdentifierId": "12",
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id
                      }
                    } else {
                      const5 = {
                        "businessIdentifierId": "12",
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id,
                        "endDate": elem.endDate
                      }
                    }
                    this.sitesService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const5).subscribe(_data9 => {
                    })
                  } else {
                    if (this.arrBasedOnVal[elem.value]) {
                      this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${this.arrBasedOnVal[elem.value]}`, constNoEndDate).subscribe(_data10 => {

                      });
                    }
                  }
                });
              }
              this.changeAccessPointsToPending(site_id, CompanayID, BvDidforsite);
              console.info("**** Create Site Done ****", fromCnS);

            });
          });

          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=SHORT_NAME`).subscribe(data3 => {
            if (data3['real-estate-asset-identifiers'].length > 0) {
              let tempShtNameRowId = data3['real-estate-asset-identifiers'][0]['rowId'];
              const const11 = { 'endDate': this.apiService.getTodayDate() }
              this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${tempShtNameRowId}`, const11).subscribe(_data4 => {

              });
            } else {
            }
          });

        });
        this.changeRealEstateAssignments(site_id, data1['legalName']);
      });
    }
  }

  changeRealEstateAssignments(site_id, CompNme) {
    this.sitesService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=${site_id}`).subscribe(data => {
      if (data['real-estate-asset-assignments'].length > 0) {
        let exist: any = false;
        let rowId = '';
        const const1 = { categoryId: this.newCategoryAssignment, categoryName: this.newCategoryName };
        const constEndDate = { "endDate": this.apiService.getTodayDate() };
        let c = 0;
        data['real-estate-asset-assignments'].forEach((element, _index) => {
          if (element.categoryCode !== '' && exist === false && element.legalEntityIdentifier === '') {
            rowId = element.rowId;
            exist = true;
          }
          if (element.legalEntityIdentifier != '' && element.endDate != '') {
            this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${element.rowId}`, constEndDate).subscribe(_data0 => {

            });
          }
          c++;
        });
        if (exist == false) {
          this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${rowId}`, const1).subscribe(_data2 => {
          });
        }
      }
    });

    const newLegalEntity = { "corporateName": CompNme, "active": '1' }
    this.sitesService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?corporateName=${CompNme}&realEstateAssetId=${site_id}`).subscribe(data014 => {
      let tempRow = '';
      let runLegal = true;
      if (data014['real-estate-asset-assignments'].length > 0) {
        const endDateSet = { endDate: this.apiService.getTodayDate() };
        const noEndD = { endDate: '' }
        for (let i = 0; i < data014['real-estate-asset-assignments'].length; i++) {
          if (data014['real-estate-asset-assignments'][i]['legalEntityIdentifier'] != '' && data014['real-estate-asset-assignments'][i]['endDate'] == '' && data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] != CompNme) {
            this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, endDateSet).subscribe(_data0 => {

            });
          }
          if (data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] == CompNme) {
            tempRow = data014['real-estate-asset-assignments'][i]['legalEntityId'];
            runLegal = false;
            if (data014['real-estate-asset-assignments'][i]['endDate'] != '') {
              this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, noEndD).subscribe(_data0 => {
              });
            }

          }
        }
      }
      if (runLegal == true) {
        this.sitesService.createLegalEntity(`${this.Config.ApiSitesUrl}legal-entities`, newLegalEntity).subscribe(data013 => {
          const newLegalPost = { 'realEstateAssetId': site_id, 'legalEntityId': data013['rowId'] }
          this.sitesService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newLegalPost).subscribe(_data015 => {

          });
        });
      }
    });
  }

  changeAccessPointsToPending(site_id, _CompanayID, _BvDidforsite) {
    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${site_id})&_page=1`).subscribe(data => {
      setTimeout(function () {
        this.reloadCurrentPage();
      }.bind(this), SupplierGroupComponent.TWO_THOUSAND_MS);
      var sitesData = data['access-points'];
      if (sitesData.length > 0) {
        const constPending = { "activeStatus": "PENDING" }
        const constActive = { "activeStatus": "ACTIVE" }
        const constEndDate = { "endDate": this.apiService.getTodayDate() }
        let OrderManuInvoi = ['P05', 'P06', 'P11'];
        data['access-points'].forEach(element => {
          //sitesData.push(ele.rowId);
          if (this.qualifierChangetoPending.indexOf(element.type) != -1) {
            if (element.activeStatus != 'PENDING') {
              if (element.activeStatus == 'ARCHIVED') {
                this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constActive).subscribe(_data0 => {
                  this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data1 => {
                  });
                });
              } else {
                this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data1 => {

                });
              }
            }
            if (OrderManuInvoi.indexOf(element.type) != -1 && element.identifier) {
              this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${element.identifier}`, constEndDate).subscribe(_data2 => {

              });
            }
          }
        });
      }
    });
  }

  getCityList(event: any, CName = "", countryName = '') {
    if (this.selectedCountry != "failed" && event.length >= SupplierGroupComponent.TWO) {
      var NCityName = "";
      if (CName == "") {
        NCityName = this.siteCityModel;
      } else {
        NCityName = CName;
      }
      let NcountryName = '';
      if (countryName == '') {
        NcountryName = this.siteCountryModel.split(' - ')[0];
      } else {
        NcountryName = countryName;
      }
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${NcountryName}&name=*${NCityName}*&_page=1&_pagesize=SupplierGroupComponent.TWENTY`).subscribe((data: any) => {
        if (data['count'] > 0) {
          this.CityNameKeyId = "";
          this.CityNameKeyId = [];
          this.CaptCity = "";
          this.CaptCity = [];
          data['cities'].forEach(element => {
            this.CaptCity.push(element.name);
            this.CityNameKeyId[element.name] = element;
          });
        } else {
          this.CaptCity = [];
        }
      });
    } else {
      this.CaptCity = [];
    }
  }

  checkSelRunSite() {
    if (this.selectedCustomCountry != '') {
      this.saveSitesDetails(this.tempVarCounList['CmpName'], this.selectedCustomCountry, this.tempVarCounList['CityName'], this.tempVarCounList['Postal'], this.tempVarCounList['CompanayID'], this.tempVarCounList['BvDidforsite'], this.tempVarCounList['fromCnS'], this.tempVarCounList['thisBvDdata'], this.tempVarCounList['times'], 'yes');
    }
  }

  fnToCallNextPage(page, maxpage) {
    let simArr = [1];
    simArr.forEach((e, index) => {
      if (this.batchObj[e] == 'done' && index + 1 == simArr.length) {
        this.setGRBatchFn(+page + 1, 'continueNoC', SupplierGroupComponent.DEFAULT_PAGE_SIZE, maxpage);
      } else if (this.batchObj[1] == 'doneFor') {
        this.setGRBatchFn(+page + 1, 'continueNoC', SupplierGroupComponent.DEFAULT_PAGE_SIZE, maxpage);
        return false;
      }
    });
  }

  changeStopBatch() {
    this.stopGRBatch = true;
    this.grTextDisp = 'Stopped!';
    this.pageBatchNo = '-';
    this.showDownloadLog = true;
    this.GRBatchIsRunning = false;
    localStorage.setItem('GRBatchIsRunning', 'no');
  }

  getTableDataForSetGRBatch(groupID) {
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${groupID}`).subscribe(data00 => {
      if (data00 != null) {
        if (this.tableDataForSetGRBatch.indexOf(data00) === -1) {
          this.tableDataForSetGRBatch.push(data00);
        }
      }
    });
  }

  downloadLogFile() {
    const element = document.getElementById('excelTableLog');
    const ws: WorkSheet = utils.table_to_sheet(element);
    const wb: WorkBook = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Set GR Batch');
    writeFile(wb, 'GRLogFile.xlsx');
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
}